import styled, { css } from 'styled-components';

export const ContactContainer = styled.section`
	${props => props.theme.breakpoints.up('xs')} {
		background-image: linear-gradient(166deg, #000000 7%, #242323 103%);
	}
	${props => props.theme.breakpoints.up('sm')} {
		background-image: linear-gradient(120deg, #000000 18%, #242323 108%);
	}
`;

export const DataContainer = styled.article`
	position: relative;

	${props => props.theme.breakpoints.up('xs')} {
		text-align: center;
		padding: 8% 8% 15% 8%;
		.contact__container {
			margin-top: 8%;
		}

		.contact__social {
			position: relative;
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			justify-content: flex-start;
		}
	}
	${props => props.theme.breakpoints.up('sm')} {
		text-align: left;
		padding: 5% 0% 6% 11%;

		.contact__social {
			padding-left: 200px;
		}

		.contact__container {
			margin-top: 2%;
		}

		h2 {
			margin-left: -4px;
		}
	}

	.contact__form {
		z-index: 2;
	}

	.button__arrow-top {
		background-color: ${props => props.theme.label.color};
		color: #ffffff;
		${props => props.theme.breakpoints.up('xs')} {
			margin-top: 10px;
			margin-bottom: 100px;
			position: relative;
		}

		${props => props.theme.breakpoints.up('sm')} {
			margin-top: 0px;
			margin-bottom: 9px;
			position: absolute;
			bottom: 5px;
			right: 6%;
		}

		&:hover {
			border: 1.5px solid ${props => props.theme.label.color};
			svg {
				fill: ${props => props.theme.label.color};
			}
		}
	}
`;

export const StyledSocialContainer = styled.div`
	display: flex;
	justify-content: flex-start;
	margin-bottom: 60px;
`;

export const ContactImage = styled.div(
	({ theme, background, mobile = false }) => css`
		position: absolute;
		background-image: url(${background});

		${theme.breakpoints.up('xs')} {
			display: none;
		}

		${theme.breakpoints.up('sm')} {
			min-height: 200px;
			background-size: cover;
			background-repeat: no-repeat;
			width: 100%;
			background-position: center bottom;
			bottom: 0px;
			left: 0px;
			display: block;
		}
		${theme.breakpoints.up('md')} {
			min-height: 17vw;
			left: -5px;
		}

		${mobile &&
		css`
			position: absolute;
			background-image: url(${background});
			${theme.breakpoints.up('xs')} {
				width: 100%;
				bottom: 10px;
				left: -0px;
				height: 150px;
				background-position: center;
				background-size: contain;
				background-repeat: no-repeat;
				display: block;
			}
			${theme.breakpoints.up('sm')} {
				display: none;
			}
		`}
	`
);
